import React from "react";
import {useFormikContext} from "formik";
import {Button, Grid} from "@material-ui/core";
import {Label} from "../../../components/formInputs";
import {ErrorHelper, SelectField, TextField, TextFieldCommon} from "../../../components/formikFormInputs";
import {UpdateMinimumContribution} from "./index";
import {setOptions} from "../../client/Estimation/V1/Components/StepThreeTwo";
import {ANNUALLY, MONTHLY} from "../../client/Estimation/V1/Components/ContributionFrequency";
import {ageDropDown, isDebug} from "../../../utils/commonUtils";
import {
    ESTIMATE_MAX_AGE,
    genderDropDown,
    healthDropdown,
    IUL710PayEnum,
    IUL710TermEnum, primaryPlansOptions,
} from "../../../constants";


interface IULEstimatorChildFormProps {
    issueAge: number;
    isNfIul:boolean;
}

const IULEstimatorChildForm = (props: IULEstimatorChildFormProps) => {
    const {issueAge, isNfIul} = props;
    const {dirty, errors, handleBlur, handleChange, handleSubmit, isSubmitting, values} = useFormikContext();

    const tobaccoDropdownOpn: object[] = [
        {id: "used", name: "Smoke",},
        {id: "notUsed", name: "Not Smoke",}
    ];
    const contributionFrequencyOpn: object[] = [
        {id: ANNUALLY, name: ANNUALLY},
        {id: MONTHLY, name: MONTHLY},
    ];

    const [ageIncrement, setAgeIncrement] = React.useState(0);
    const [beginDistributions, setBeginDistributions] = React.useState(setOptions(ESTIMATE_MAX_AGE));
    const [endDistributions, setEndDistributions] = React.useState<any[]>(setOptions(ESTIMATE_MAX_AGE));

    const renderField = ({grid, ...field}: any, index: number) => (
            <Grid item xs={12} sm={grid} key={index}>
                <TextFieldCommon
                        values={values}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        InputLabelProps={{disabled: false}}
                        {...field}
                />
                <ErrorHelper errors={errors} name={field.name}/>
            </Grid>
    );

    const formFields = [
        {
            component: SelectField,
            disabled: true,
            grid: 6,
            label: <Label label={"Age"} required={true}/>,
            name: "issueAge",
            options: ageDropDown(),
        },
        {
            component: SelectField,
            disabled: true,
            grid: 6,
            label: <Label label={"Gender"} required={true}/>,
            name: "gender",
            options: genderDropDown,
        },
        {
            component: SelectField,
            grid: 6,
            label: <Label label={"Health"} required={true}/>,
            name: "healthType",
            options: healthDropdown.map((option: any) => ({...option, key: option.value})),
        },
        {
            component: SelectField,
            grid: 6,
            label: <Label label={"Tobacco/Marijuana Use"} required={true}/>,
            name: "tobacco",
            options: tobaccoDropdownOpn,
        },
        {
            component: SelectField,
            grid: 6,
            label: <Label label={"Contribution Years"} required={true}/>,
            name: "primaryFocusPlan",
            onSelectChange: (value: string) => value === IUL710PayEnum.IUL7Pay ? setAgeIncrement(IUL710TermEnum.IUL7) : setAgeIncrement(IUL710TermEnum.IUL10),
            options: primaryPlansOptions,
        },
        {
            component: SelectField,
            grid: 6,
            label: <Label label={"Premium Schedule"} required={true}/>,
            name: "contributionFrequency",
            options: contributionFrequencyOpn,
        },
        {
            component: SelectField,
            grid: 6,
            label: <Label label={"Income Start Age"} required={true}/>,
            name: "beginDistributions",
            options: beginDistributions,
        },
        {
            component: SelectField,
            grid: 6,
            label: <Label label={"Income End Age"} required={true}/>,
            name: "endDistributions",
            options: endDistributions,
        },
        {
            component: TextField,
            grid: 12,
            label: <Label label={`Enter ${values && (values as any).contributionFrequency} Contribution amount`} required={true}/>,
            name: "contributionAmount",
        },
    ];

    React.useEffect(() => {
        if (!!issueAge) {
            const beginDistVal: number = issueAge + ageIncrement;
            const res: any[] = setOptions(beginDistVal);
            setBeginDistributions(res);
            setEndDistributions(res);
        }

    }, [issueAge, ageIncrement]);


    return (

                <form
                        onSubmit={handleSubmit}
                        style={{marginBottom: "60px"}}
                >
                    <Grid container spacing={3} className="mt15">
                        {
                            formFields.map(renderField)
                        }
                        <Grid item xs={12} container justify="center">
                            <Button
                                    className="mb20 mt20"
                                    color="primary"
                                    disabled={!dirty || isSubmitting}
                                    type="submit"
                                    variant="contained"
                            >
                                Calculate
                            </Button>

                            <UpdateMinimumContribution isNfIul={isNfIul}/>
                        </Grid>
                    </Grid>
                </form>
    );
};


export default IULEstimatorChildForm;
